import { HAS_WINDOW } from './constants';
import { UserAddressProps } from '../types/ContextProps';

export const setLocalStorage = (name: string, value: string) => {
  if (HAS_WINDOW) {
    localStorage.setItem(name, value);
  }
};

export const getLocalStorage = (name: string) => {
  if (HAS_WINDOW) {
    return localStorage.getItem(name);
  } else {
    return;
  }
};

export const getFullLocalStorage = () => {
  const postalCode = getLocalStorage('postalCode');
  const method = getLocalStorage('method');
  const deliveryInfos = JSON.parse(getLocalStorage('deliveryInfos') ?? '{}');

  const userAddressInfos: UserAddressProps = {
    postalCode: postalCode ?? '00000-000',
    city: deliveryInfos?.city,
    uf: deliveryInfos?.uf,
  };

  const regionalized: string | undefined = method ?? undefined;

  return {
    regionalized,
    deliveryInfos: regionalized ? deliveryInfos : undefined,
    userAddressInfos,
  };
};
